const site = 'https://popivnenko.com';
const publicPages = new Set(['/', '/products', '/pricing', '/services', '/about', '/reviews', '/terms-of-use', '/privacy-policy', '/refund-policy']);

export function publicShareUrl(pathname: string, search = ''): string {
    const path = pathname.replace(/\/+$/, '').toLowerCase() || '/';
    if (!publicPages.has(path) && !/^\/certificate\/[a-z0-9_-]+$/i.test(pathname.replace(/\/+$/, ''))) return site + '/';
    const url = new URL(path.startsWith('/certificate/') ? pathname.replace(/\/+$/, '') : path, site);
    // Share only catalogue selections, never arbitrary account/tracking parameters.
    const parameter = path === '/products' ? 'course' : path === '/services' ? 'service' : null;
    if (parameter) {
        const value = new URLSearchParams(search).getAll(parameter).find(value => /^[a-zA-Z0-9._-]{1,250}$/.test(value));
        if (value) url.searchParams.set(parameter, value);
    }
    return url.href;
}

export function socialShareLinks(url: string) {
    const encoded = encodeURIComponent(url);
    return [
        { name: 'Facebook', icon: 'pi-facebook', href: `https://www.facebook.com/sharer/sharer.php?u=${encoded}` },
        { name: 'X', icon: 'pi-twitter', href: `https://x.com/intent/tweet?url=${encoded}` },
        { name: 'LinkedIn', icon: 'pi-linkedin', href: `https://www.linkedin.com/sharing/share-offsite/?url=${encoded}` },
        { name: 'WhatsApp', icon: 'pi-whatsapp', href: `https://wa.me/?text=${encoded}` },
    ];
}
